import React from 'react';
import { Col, FormGroup, Row } from "react-bootstrap";
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { SetupTab } from 'areas/shared/pages/setup';
import { AdminAppIdHeader } from 'areas/shared/components';
import { Label, Button } from 'fw/components';
import * as App from 'modules/app/App'
import * as API from 'modules/app/API';
import SystemAPI from 'fw/system/API';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DocumentUpload } from "areas/shared/controls";
import * as Notifications from 'fw/globals/Notifications';
import { TooltipCode } from 'areas/shared/consts';
import AdminStepToolbar from 'areas/admin/certification/shared/AdminStepToolbar';

class Declaration extends SetupTab {
    initialForm() {
        return {
            disableSubmit: false,
            rowVersion: null,
            tooltips: []
        }
    }

    skipValidations() {
        return App.hasPrivilege("AdminSkipValidations");
    }

    ready = () => {
    }

    updatePostData = (form, dirty) => {
        this.setState({ form });

        if (dirty === true)
            this.dirt();
    }

    privileges() {
        return {
            edit: App.hasPrivilege("AdminAppManagementEdit")
        }
    }

    downloadDeclarationForm = () => {
        new SystemAPI().download({
            storageToken: this.state.form.declarationFormStorageToken,
            fileName: this.state.form.declarationFormFileName
        });
    };

    urls() {
        return {
            get: API.Admin.url('/certification/getDeclaration'),
            save: API.Admin.url('/certification/saveDeclaration'),
        }
    }

    getRequest(selectedId) {
        return {
            certificationKey: selectedId,
            queueTypeCode: this.props.queueTypeCode
        }
    }

    handleSubmit = () => {
        var url = API.Admin.url('/certification/submitDeclaration');
        var rq = this.saveRequest();
        let me = this;

        new SystemAPI().post(url, rq, {
            success: (r) => {
                Notifications.success(r.message);

                this.setState({
                    title: (r.data && r.data.title) || this.state.title,
                    saving: false,
                    dirty: false,
                    disableSubmit: true,
                    rowVersion: r.data.rowVersion,
                    form: {
                        ...this.state.form,
                        ...r.data,
                        original: {
                            ...this.state.form,
                            ...r.data
                        }
                    }
                });
            },
            error: r => {
                me.setState({ saving: false });
                this.props.onError(r.error);
            }
        });
        return false;
    }

    saveRequest() {
        return {
            certificationId: this.state.form.certificationId,
            declarationStorageToken: this.state.form.declarationStorageToken,
            declarationFileName: this.state.form.declarationFileName,
        }
    }

    handleUploadChange = (file) => {
        let form = this.state.form;

        form.declarationStorageToken = file.storageToken;
        form.declarationFileName = file.fileName;

        this.updatePostData(form, true)
    };

    renderAdminStepToolbar = () => {
        const disableCancel = !this.state.buttons.cancel;
        // Enable save if present, and form is dirty
        const disableSave = !this.state.buttons.save;
        //Show cancel
        const showCancel = this.state.showButtons.cancel;
        //Show save 
        const showSave = this.state.showButtons.save && this.state.enabled;
        
        return (
            <AdminStepToolbar
                ref={(c) => { this._ast = c }}
                onSave={this.handleSubmit}
                certificationKey={this.props.selectedId}
                reviewTypeCode={'DEC'}
                queueTypeCode={this.props.queueTypeCode}
                showCancel={(showCancel && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                showSave={(showSave && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                onCancel={this.handleCancel}
                disableCancel={disableCancel}
                disableSave={disableSave || !this.state.form.canSubmit || this.state.disableSubmit}
                savelabel="Submit Declaration"
                setupProps={this.props.setupProps}
                handleTabSelect={this.props.handleTabSelect}
            />)
    }

    renderButtons = () => {
        return (
            <React.Fragment>
                <hr />
                <Row>
                    <Col md={12}>
                        {this.renderAdminStepToolbar()}
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <h3 style={{ marginTop: "0px", position: "relative" }}>
                            <AdminAppIdHeader appId={this.state.form.certificationId} daysOpen={this.props.setupProps.daysOpen} certificationType={this.state.form.certificationType} certificationStatus={this.state.form.certificationStatus} />
                        </h3>
                        <hr />
                        <h3>
                            Please print and complete the Declaration Form - Upload when completed
                            {this.renderAdminStepToolbar()}
                        </h3>
                        <hr />
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <p>
                            I (we) have completed and submitted the information as requested by the National Veteran Business Development
                            Council and hereby certify that the information contained herein and in all attachments and supporting
                            documents are true, correct, and accurate to the best of my (our) knowledge and belief. I (we) understand that
                            this Declaration of Certification of Veteran Status and the criteria set forth have been developed according
                            to the guidelines established by the National Veteran Business Development Council. The certification, when
                            granted, will be for a one (1) year term. I (we) further understand that completion and submission of this
                            form, together with all attachments and supporting documents hereto, is not necessarily the sole criteria for
                            determining certification of veteran status; additional documents may be required by the National Veteran
                            Business Development Council.
                                    </p>
                        <p>
                            I (we) acknowledge that if the NVBDC discovers that a statement has been made therein which the applicant
                            knows to be false, the certification process will be terminated immediately. I (we) agree that all materials
                            submitted with this application shall become the property of the NVBDC and that all submitted documentation
                            will be held in strict confidence.
                                    </p>
                        <p>
                            I (we) further agree that once certified, the continued certification and registration by the NVBDC will be
                            according to the guidelines, rules, and regulations of the NVBDC and may be amended from time to time.
                            Termination of my (our) status may be based upon, but not necessarily limited to, any one of the following:
                                    </p>
                        <p>
                            1. Cessation of operation by the veteran business.
                                        <br />
                            2. Discovery that any false information was knowingly supplied to the NVBDC in the completion of this form or
                            as contained in any submitted attachments or supporting documents.
                                        <br />
                            3. Failure to provide timely notice or withholding of any notice to the NVBDC of the transfer or loss of
                            ownership and/or management and control of the business by its veteran group members.
                                        <br />
                            4. Failures or refusal to allow the NVBDC and/or its authorized representatives access to the company's place
                            of business upon reasonable notice and demand for the purpose of a site visit.
                                        <br />
                            5. Sales, exchange, or transfer of ownership of the veteran business, if such transfer results in the loss of
                            control and ownership of the business by the veteran group members.
                                    </p>
                        <p>
                            I (we) understand and agree that the NVBDC reserves the right to request any further and additional
                            information that may be necessary to substantiate the information and representations made by the applicant(s)
                            for certification. I (we) declare that the company in whose name this application is being submitted is at
                            least fifty-one percent (51%) owned by one or more veteran individuals (as defined therein) and such
                            individuals control, operate, and manage the company.
                                    </p>
                        <p>
                            The undersigned hereby agrees (agree) to hold the NVBDC free and harmless from any and all claims, demands,
                            and damages whatsoever arising from the presentation of this application and agrees to indemnify and hold the
                            NVBDC harmless for any and all liability in connection with the certification of the information contained in
                            this application.
                                    </p>
                        <p>
                            The undersigned hereby declares (declare) under penalty of perjury that I (we) have read this Declaration of
                            Certification of Veteran Status completely and all statements made in this application and any attachments and
                            supporting documents hereto are true and correct. I (we) understand that the registration fee is included and
                            non-refundable.
                                    </p>
                        <p>
                            <br />
                        </p>
                        <hr />
                    </Col>
                </Row>
                <Row>
                    <Col md={2}>
                        <div>
							<Button type="button" bsStyle="link" onClick={() => this.downloadDeclarationForm()} style={{ textAlign: 'center', display: 'block' }}>
                                Download Declaration
                                <br />
                                <FontAwesomeIcon icon={faPrint} size='3x' color='black' style={{ textAlign: 'center' }} />
							</Button>
                        </div>
                    </Col>
                    <Col md={6}>
                    </Col>
                    <Col md={4}>
                        <FormGroup>
                            <Label htmlFor="declarationUpload" tip={this.setTip(TooltipCode.DECLARATION.DECLARATIONCERUPLOAD)} required>Declaration of Certification Upload</Label>
                            <DocumentUpload
                                storageToken={this.state.form.declarationStorageToken}
                                fileName={this.state.form.declarationFileName}
                                onChange={file => this.handleUploadChange(file)}
                                wrapFileNameLength={30}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </React.Fragment >
        )
    }
}

export default Declaration; 



// WEBPACK FOOTER //
// ./src/areas/admin/certification/certificationInfo/declaration/Declaration.js